import React, {Component} from "react";
import styles from './FJWatermarkView.module.less';
import classNames from 'classnames';
import FJLocalStore from "../../../store/FJLocalStore";
import FJWatermarkImageContainer from "../container/FJWatermarkImageContainer";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJWatermarkTextContainer from "../container/FJWatermarkTextContainer";
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJResourceHeader from "./FJResourceHeader";
import FJVipMark from "../../../common/component/FJVipMark";

function MarkType(props) {
  const {WATERMARK_IMAGE, WATERMARK_TEXT} = FJCoreConstant;
  const {activeType, onClickFun} = props;
  return (
    <div className={styles.type_box}>
      <MarkItem active={activeType === WATERMARK_TEXT}
                text={FJLocalStore._('watermark_text')}
                onClick={onClickFun}
                type={WATERMARK_TEXT}/>
      <MarkItem active={activeType === WATERMARK_IMAGE}
                text={FJLocalStore._('watermark_image')}
                onClick={onClickFun}
                type={WATERMARK_IMAGE}/>
    </div>
  )
}

function MarkItem(props) {
  const {active, onClick, type, text} = props;
  const clickFunc = () => {
    onClick(type)
  };
  return (
    <div className={classNames(styles.type_list, {[styles.active]: active})}
         onClick={clickFunc}>
      <span className={styles.type_text}>{text}</span>
    </div>
  );
}

function MarkTypeLine(props) {
  const isText = props.activeType === FJCoreConstant.WATERMARK_TEXT;
  return (
    <div className={styles.type_line_box}>
      <div className={styles.type_line}>
        <div className={classNames(styles.active_line, {
          [styles.left]: isText,
          [styles.right]: !isText,
        })}/>
      </div>
    </div>
  )
}

class FJWatermarkView extends Component {

  _renderVipMark = () => {
    const {hasVipTip} = this.props;
    return (
      hasVipTip && <FJVipMark />
    );
  };

  render() {
    const {watermarkType, changeWatermarkTypeAction} = this.props;
    const {WATERMARK_TEXT, WATERMARK_IMAGE} = FJCoreConstant;
    return (
      <div className={styles.list_box}>
				<FJCustomScroll>
					<FJResourceHeader hasLine
                            onRender={this._renderVipMark}
                            title={FJLocalStore._('watermark')} />
					<div className={styles.content_box}>
						<MarkType onClickFun={changeWatermarkTypeAction}
											activeType={watermarkType}
						/>
						<MarkTypeLine activeType={watermarkType}/>
						<FJWatermarkTextContainer isShow={watermarkType === WATERMARK_TEXT}/>
						<FJWatermarkImageContainer isShow={watermarkType === WATERMARK_IMAGE}/>
					</div>
				</FJCustomScroll>
      </div>
    )
  }

}


export default FJWatermarkView;